import {
  BriefcaseBusiness,
  CalendarDays,
  GraduationCap,
  HeartPulse,
  PartyPopper,
  Scissors,
  type LucideIcon,
} from 'lucide-react';

export type SolutionStatus = 'available' | 'soon';

export interface SolutionItem {
  slug: string;
  label: string;
  href?: string;
  eyebrow: string;
  title: string;
  description: string;
  icon: LucideIcon;
  status: SolutionStatus;
}

export const solutions: SolutionItem[] = [
  {
    slug: 'belleza',
    label: 'Belleza',
    href: '/belleza/',
    eyebrow: 'Salones, barberías y estética',
    title: 'Agenda para negocios de belleza',
    description: 'Organiza citas, profesionales, servicios y clientes desde una agenda pensada para atención recurrente.',
    icon: Scissors,
    status: 'available',
  },
  {
    slug: 'salud',
    label: 'Salud',
    href: '/salud/',
    eyebrow: 'Consultorios y bienestar',
    title: 'Reservas para servicios de salud',
    description: 'Prepara disponibilidad, confirmaciones y recordatorios para agendas de atención profesional.',
    icon: HeartPulse,
    status: 'available',
  },
  {
    slug: 'clases',
    label: 'Clases',
    href: '/clases/',
    eyebrow: 'Profesores y academias',
    title: 'Agenda para clases y asesorías',
    description: 'Gestiona sesiones, horarios, alumnos y reservas sin depender de mensajes manuales todo el día.',
    icon: GraduationCap,
    status: 'available',
  },
  {
    slug: 'servicios-profesionales',
    label: 'Servicios profesionales',
    href: '/servicios-profesionales/',
    eyebrow: 'Consultores, técnicos y especialistas',
    title: 'Agenda para servicios profesionales',
    description: 'Centraliza solicitudes, disponibilidad y citas para negocios que venden tiempo experto.',
    icon: BriefcaseBusiness,
    status: 'available',
  },
  {
    slug: 'reservas-eventos',
    label: 'Reservas para eventos',
    eyebrow: 'Espacios y experiencias',
    title: 'Reservas para eventos',
    description: 'Una solución para reservas por fecha, cupos y disponibilidad compartida.',
    icon: PartyPopper,
    status: 'soon',
  },
];

export const featuredSolution = {
  icon: CalendarDays,
  title: 'Agenda centralizada',
  description: 'Citas, clientes y disponibilidad conectadas desde el primer día.',
};

export function getSolutionBySlug(slug: string) {
  return solutions.find((solution) => solution.slug === slug);
}
